import React from "react"
import types from "prop-types"

const SectionContainer = ({ children = null, description = "", name = "" }) => (
  <div className="mb-8 last:mb-0">
    {
      (description || name) && (
        <div className="mb-6">
          {
            name && (
              <p className="font-medium text-2xl leading-9">{name}</p>
            )
          }
          {
            description && (
              <p className="font-normal text-sm">{description}</p>
            )
          }
        </div>
      )
    }
    {children}
  </div>
)

SectionContainer.propTypes = {
  children: types.node,
  description: types.string,
  name: types.string,
}

export default SectionContainer
